/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as SuppliersRouteImport } from './routes/suppliers'
import { Route as StoresRouteImport } from './routes/stores'
import { Route as StaffRouteImport } from './routes/staff'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as OrganizationsRouteImport } from './routes/organizations'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as CompaniesRouteImport } from './routes/companies'
import { Route as CatalogGenRouteImport } from './routes/catalog-gen'
import { Route as CatalogRouteImport } from './routes/catalog'
import { Route as BrandsRouteImport } from './routes/brands'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SuppliersIndexRouteImport } from './routes/suppliers/index'
import { Route as CompaniesIndexRouteImport } from './routes/companies/index'
import { Route as CatalogIndexRouteImport } from './routes/catalog.index'
import { Route as SuppliersIdRouteImport } from './routes/suppliers/$id'
import { Route as CompaniesIdRouteImport } from './routes/companies/$id'
import { Route as CatalogTaxonomyRouteImport } from './routes/catalog.taxonomy'
import { Route as CatalogImportRouteImport } from './routes/catalog.import'
import { Route as CatalogSplatRouteImport } from './routes/catalog.$'
import { Route as CatalogImportIndexRouteImport } from './routes/catalog.import.index'
import { Route as CatalogImportAddRouteImport } from './routes/catalog.import.add'
import { Route as CatalogImportIdRouteImport } from './routes/catalog.import.$id'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const SuppliersRoute = SuppliersRouteImport.update({
  id: '/suppliers',
  path: '/suppliers',
  getParentRoute: () => rootRouteImport,
} as any)
const StoresRoute = StoresRouteImport.update({
  id: '/stores',
  path: '/stores',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffRoute = StaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsRoute = OrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesRoute = CompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogGenRoute = CatalogGenRouteImport.update({
  id: '/catalog-gen',
  path: '/catalog-gen',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogRoute = CatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandsRoute = BrandsRouteImport.update({
  id: '/brands',
  path: '/brands',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SuppliersIndexRoute = SuppliersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SuppliersRoute,
} as any)
const CompaniesIndexRoute = CompaniesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CompaniesRoute,
} as any)
const CatalogIndexRoute = CatalogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CatalogRoute,
} as any)
const SuppliersIdRoute = SuppliersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SuppliersRoute,
} as any)
const CompaniesIdRoute = CompaniesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CompaniesRoute,
} as any)
const CatalogTaxonomyRoute = CatalogTaxonomyRouteImport.update({
  id: '/taxonomy',
  path: '/taxonomy',
  getParentRoute: () => CatalogRoute,
} as any)
const CatalogImportRoute = CatalogImportRouteImport.update({
  id: '/import',
  path: '/import',
  getParentRoute: () => CatalogRoute,
} as any)
const CatalogSplatRoute = CatalogSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => CatalogRoute,
} as any)
const CatalogImportIndexRoute = CatalogImportIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CatalogImportRoute,
} as any)
const CatalogImportAddRoute = CatalogImportAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => CatalogImportRoute,
} as any)
const CatalogImportIdRoute = CatalogImportIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CatalogImportRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/brands': typeof BrandsRoute
  '/catalog': typeof CatalogRouteWithChildren
  '/catalog-gen': typeof CatalogGenRoute
  '/companies': typeof CompaniesRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/organizations': typeof OrganizationsRoute
  '/settings': typeof SettingsRoute
  '/staff': typeof StaffRoute
  '/stores': typeof StoresRoute
  '/suppliers': typeof SuppliersRouteWithChildren
  '/users': typeof UsersRoute
  '/catalog/$': typeof CatalogSplatRoute
  '/catalog/import': typeof CatalogImportRouteWithChildren
  '/catalog/taxonomy': typeof CatalogTaxonomyRoute
  '/companies/$id': typeof CompaniesIdRoute
  '/suppliers/$id': typeof SuppliersIdRoute
  '/catalog/': typeof CatalogIndexRoute
  '/companies/': typeof CompaniesIndexRoute
  '/suppliers/': typeof SuppliersIndexRoute
  '/catalog/import/$id': typeof CatalogImportIdRoute
  '/catalog/import/add': typeof CatalogImportAddRoute
  '/catalog/import/': typeof CatalogImportIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/brands': typeof BrandsRoute
  '/catalog-gen': typeof CatalogGenRoute
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/organizations': typeof OrganizationsRoute
  '/settings': typeof SettingsRoute
  '/staff': typeof StaffRoute
  '/stores': typeof StoresRoute
  '/users': typeof UsersRoute
  '/catalog/$': typeof CatalogSplatRoute
  '/catalog/taxonomy': typeof CatalogTaxonomyRoute
  '/companies/$id': typeof CompaniesIdRoute
  '/suppliers/$id': typeof SuppliersIdRoute
  '/catalog': typeof CatalogIndexRoute
  '/companies': typeof CompaniesIndexRoute
  '/suppliers': typeof SuppliersIndexRoute
  '/catalog/import/$id': typeof CatalogImportIdRoute
  '/catalog/import/add': typeof CatalogImportAddRoute
  '/catalog/import': typeof CatalogImportIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/brands': typeof BrandsRoute
  '/catalog': typeof CatalogRouteWithChildren
  '/catalog-gen': typeof CatalogGenRoute
  '/companies': typeof CompaniesRouteWithChildren
  '/dashboard': typeof DashboardRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/organizations': typeof OrganizationsRoute
  '/settings': typeof SettingsRoute
  '/staff': typeof StaffRoute
  '/stores': typeof StoresRoute
  '/suppliers': typeof SuppliersRouteWithChildren
  '/users': typeof UsersRoute
  '/catalog/$': typeof CatalogSplatRoute
  '/catalog/import': typeof CatalogImportRouteWithChildren
  '/catalog/taxonomy': typeof CatalogTaxonomyRoute
  '/companies/$id': typeof CompaniesIdRoute
  '/suppliers/$id': typeof SuppliersIdRoute
  '/catalog/': typeof CatalogIndexRoute
  '/companies/': typeof CompaniesIndexRoute
  '/suppliers/': typeof SuppliersIndexRoute
  '/catalog/import/$id': typeof CatalogImportIdRoute
  '/catalog/import/add': typeof CatalogImportAddRoute
  '/catalog/import/': typeof CatalogImportIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/brands'
    | '/catalog'
    | '/catalog-gen'
    | '/companies'
    | '/dashboard'
    | '/login'
    | '/onboarding'
    | '/organizations'
    | '/settings'
    | '/staff'
    | '/stores'
    | '/suppliers'
    | '/users'
    | '/catalog/$'
    | '/catalog/import'
    | '/catalog/taxonomy'
    | '/companies/$id'
    | '/suppliers/$id'
    | '/catalog/'
    | '/companies/'
    | '/suppliers/'
    | '/catalog/import/$id'
    | '/catalog/import/add'
    | '/catalog/import/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/brands'
    | '/catalog-gen'
    | '/dashboard'
    | '/login'
    | '/onboarding'
    | '/organizations'
    | '/settings'
    | '/staff'
    | '/stores'
    | '/users'
    | '/catalog/$'
    | '/catalog/taxonomy'
    | '/companies/$id'
    | '/suppliers/$id'
    | '/catalog'
    | '/companies'
    | '/suppliers'
    | '/catalog/import/$id'
    | '/catalog/import/add'
    | '/catalog/import'
  id:
    | '__root__'
    | '/'
    | '/brands'
    | '/catalog'
    | '/catalog-gen'
    | '/companies'
    | '/dashboard'
    | '/login'
    | '/onboarding'
    | '/organizations'
    | '/settings'
    | '/staff'
    | '/stores'
    | '/suppliers'
    | '/users'
    | '/catalog/$'
    | '/catalog/import'
    | '/catalog/taxonomy'
    | '/companies/$id'
    | '/suppliers/$id'
    | '/catalog/'
    | '/companies/'
    | '/suppliers/'
    | '/catalog/import/$id'
    | '/catalog/import/add'
    | '/catalog/import/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BrandsRoute: typeof BrandsRoute
  CatalogRoute: typeof CatalogRouteWithChildren
  CatalogGenRoute: typeof CatalogGenRoute
  CompaniesRoute: typeof CompaniesRouteWithChildren
  DashboardRoute: typeof DashboardRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  OrganizationsRoute: typeof OrganizationsRoute
  SettingsRoute: typeof SettingsRoute
  StaffRoute: typeof StaffRoute
  StoresRoute: typeof StoresRoute
  SuppliersRoute: typeof SuppliersRouteWithChildren
  UsersRoute: typeof UsersRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suppliers': {
      id: '/suppliers'
      path: '/suppliers'
      fullPath: '/suppliers'
      preLoaderRoute: typeof SuppliersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stores': {
      id: '/stores'
      path: '/stores'
      fullPath: '/stores'
      preLoaderRoute: typeof StoresRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff': {
      id: '/staff'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof StaffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations': {
      id: '/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof OrganizationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies': {
      id: '/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof CompaniesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog-gen': {
      id: '/catalog-gen'
      path: '/catalog-gen'
      fullPath: '/catalog-gen'
      preLoaderRoute: typeof CatalogGenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog': {
      id: '/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof CatalogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brands': {
      id: '/brands'
      path: '/brands'
      fullPath: '/brands'
      preLoaderRoute: typeof BrandsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/suppliers/': {
      id: '/suppliers/'
      path: '/'
      fullPath: '/suppliers/'
      preLoaderRoute: typeof SuppliersIndexRouteImport
      parentRoute: typeof SuppliersRoute
    }
    '/companies/': {
      id: '/companies/'
      path: '/'
      fullPath: '/companies/'
      preLoaderRoute: typeof CompaniesIndexRouteImport
      parentRoute: typeof CompaniesRoute
    }
    '/catalog/': {
      id: '/catalog/'
      path: '/'
      fullPath: '/catalog/'
      preLoaderRoute: typeof CatalogIndexRouteImport
      parentRoute: typeof CatalogRoute
    }
    '/suppliers/$id': {
      id: '/suppliers/$id'
      path: '/$id'
      fullPath: '/suppliers/$id'
      preLoaderRoute: typeof SuppliersIdRouteImport
      parentRoute: typeof SuppliersRoute
    }
    '/companies/$id': {
      id: '/companies/$id'
      path: '/$id'
      fullPath: '/companies/$id'
      preLoaderRoute: typeof CompaniesIdRouteImport
      parentRoute: typeof CompaniesRoute
    }
    '/catalog/taxonomy': {
      id: '/catalog/taxonomy'
      path: '/taxonomy'
      fullPath: '/catalog/taxonomy'
      preLoaderRoute: typeof CatalogTaxonomyRouteImport
      parentRoute: typeof CatalogRoute
    }
    '/catalog/import': {
      id: '/catalog/import'
      path: '/import'
      fullPath: '/catalog/import'
      preLoaderRoute: typeof CatalogImportRouteImport
      parentRoute: typeof CatalogRoute
    }
    '/catalog/$': {
      id: '/catalog/$'
      path: '/$'
      fullPath: '/catalog/$'
      preLoaderRoute: typeof CatalogSplatRouteImport
      parentRoute: typeof CatalogRoute
    }
    '/catalog/import/': {
      id: '/catalog/import/'
      path: '/'
      fullPath: '/catalog/import/'
      preLoaderRoute: typeof CatalogImportIndexRouteImport
      parentRoute: typeof CatalogImportRoute
    }
    '/catalog/import/add': {
      id: '/catalog/import/add'
      path: '/add'
      fullPath: '/catalog/import/add'
      preLoaderRoute: typeof CatalogImportAddRouteImport
      parentRoute: typeof CatalogImportRoute
    }
    '/catalog/import/$id': {
      id: '/catalog/import/$id'
      path: '/$id'
      fullPath: '/catalog/import/$id'
      preLoaderRoute: typeof CatalogImportIdRouteImport
      parentRoute: typeof CatalogImportRoute
    }
  }
}

interface CatalogImportRouteChildren {
  CatalogImportIdRoute: typeof CatalogImportIdRoute
  CatalogImportAddRoute: typeof CatalogImportAddRoute
  CatalogImportIndexRoute: typeof CatalogImportIndexRoute
}

const CatalogImportRouteChildren: CatalogImportRouteChildren = {
  CatalogImportIdRoute: CatalogImportIdRoute,
  CatalogImportAddRoute: CatalogImportAddRoute,
  CatalogImportIndexRoute: CatalogImportIndexRoute,
}

const CatalogImportRouteWithChildren = CatalogImportRoute._addFileChildren(
  CatalogImportRouteChildren,
)

interface CatalogRouteChildren {
  CatalogSplatRoute: typeof CatalogSplatRoute
  CatalogImportRoute: typeof CatalogImportRouteWithChildren
  CatalogTaxonomyRoute: typeof CatalogTaxonomyRoute
  CatalogIndexRoute: typeof CatalogIndexRoute
}

const CatalogRouteChildren: CatalogRouteChildren = {
  CatalogSplatRoute: CatalogSplatRoute,
  CatalogImportRoute: CatalogImportRouteWithChildren,
  CatalogTaxonomyRoute: CatalogTaxonomyRoute,
  CatalogIndexRoute: CatalogIndexRoute,
}

const CatalogRouteWithChildren =
  CatalogRoute._addFileChildren(CatalogRouteChildren)

interface CompaniesRouteChildren {
  CompaniesIdRoute: typeof CompaniesIdRoute
  CompaniesIndexRoute: typeof CompaniesIndexRoute
}

const CompaniesRouteChildren: CompaniesRouteChildren = {
  CompaniesIdRoute: CompaniesIdRoute,
  CompaniesIndexRoute: CompaniesIndexRoute,
}

const CompaniesRouteWithChildren = CompaniesRoute._addFileChildren(
  CompaniesRouteChildren,
)

interface SuppliersRouteChildren {
  SuppliersIdRoute: typeof SuppliersIdRoute
  SuppliersIndexRoute: typeof SuppliersIndexRoute
}

const SuppliersRouteChildren: SuppliersRouteChildren = {
  SuppliersIdRoute: SuppliersIdRoute,
  SuppliersIndexRoute: SuppliersIndexRoute,
}

const SuppliersRouteWithChildren = SuppliersRoute._addFileChildren(
  SuppliersRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BrandsRoute: BrandsRoute,
  CatalogRoute: CatalogRouteWithChildren,
  CatalogGenRoute: CatalogGenRoute,
  CompaniesRoute: CompaniesRouteWithChildren,
  DashboardRoute: DashboardRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  OrganizationsRoute: OrganizationsRoute,
  SettingsRoute: SettingsRoute,
  StaffRoute: StaffRoute,
  StoresRoute: StoresRoute,
  SuppliersRoute: SuppliersRouteWithChildren,
  UsersRoute: UsersRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
